import moment from 'moment';
import Network from "./network";
import Metric from "./metric";
import Google from "./google";
import Callrail from "./callrail";
import Calltrackingmetrics from "./calltrackingmetrics";
import Member from "./member";





 


        class Analytics{
         constructor(params,o=false){
            this.tbl = (o) ? params.permissionsTable : {};
            this.dashboardAccess = this.dashboardAccess.bind(this);
            this.generic = {
                id:false,
                name:"",
                subTitle:"",
                description:"Client",
            }
            this.access = {};
            if (!o){
            for (var pt of params.permissionsTable){
               this.tbl[pt.accountId+"-"+pt.pivotAccountId] = (this.tbl[pt.accountId+"-"+pt.pivotAccountId]) ? this.tbl[pt.accountId+"-"+pt.pivotAccountId] : [];
               this.tbl[pt.accountId+"-"+pt.pivotAccountId].push(pt);
            }
        }
            this._types = {
                
                "analytics":Member,
                "google":Google,
                "network":Network,
                "metric":Metric,
                "callrail":Callrail,
                "calltrackingmetrics":Calltrackingmetrics
                
                
            }
                for (var ks of Object.keys(params.accounts)){
                  if (this._types[ks.toLowerCase()]){
                     for (var ok of Object.keys(params.accounts[ks])){
                        var acs = JSON.parse(JSON.stringify(params.accounts));
                        var o = JSON.parse(JSON.stringify(acs[ks][ok]));
                        var model;
                        if (ks.toLowerCase() == "network"){
                          model = new this._types[ks.toLowerCase()]({accounts:acs,permissionsTable:this.tbl},o,this.dashboardAccess);
                        }else{
                  model = new this._types[ks.toLowerCase()]({accounts:acs,permissionsTable:this.tbl},o);
                        }
                  this.setModelParameters(model)
                     }
                  }
              }
               
               
              
      }
   


      setOriginAccountId(id){
        this.originAccountId = id;
        this.generic.originAccountId = id;
      }
      setOriginId(id){
        this.originId = id;
        this.generic.originId = id;
      }
          dashboardAccess(arr){
            arr.map((a) => {
              this.access[a] = true;
            })
          }
        
          setId(val){
            this.generic.id = val;
            this.id = val;
          }
          setFullName(str){
            this.generic.name = str;
          }
          setValue(str){
            this.generic.subTitle = str;
          }
            
          setAnalyticsType(str){
            this.generic.description = str;
          }
          
          setModelParameters(params){
            var ac = params.accountType == this.accountType ? "Member" : "Analytics";
              this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
              this[params.accountType].push(params);
          }
        }
        export default Analytics;
                  